import React, { Component } from 'react';
import Hero from "../modules/Hero/Hero";
import RegisterBlock from "../modules/RegisterBlock";
import TwinColumn from "../modules/TwinColumn";
import globals from '../globals';
import TextImageHeading from "../modules/TextImageHeading";
import Heading from "../elements/Heading";
import ThreeColumnIcons from "../modules/ThreeColumnIcons/ThreeColumnIcons";
import HelmetDefault from "../layout/HelmetDefault";

class ManagedServices extends Component {

    constructor(props) {
        super(props);

        this.state = {
            title: '',
            subTitle: '',
            leadCopy: [],
            twinColumn: {},
            textImageHeading: {},
            whyManaged: {
                title: '',
                content: ''
            },
            networkSolution: {},
            seoTitle: '',
            seoDescription: '',
            dataReceived: false
        };
    }

    componentDidMount() {
        this.getData();
    }

    componentWillUnmount() {
        globals.destroy(this.controller);
    }

    getData() {
        fetch('/api/managed-services')
            .then(result => result.json())
            .then((result) => {
                this.setState(result);
                this.setDataReceived();
                globals.animatePageIn(this.container);
                this.controller = globals.genericAnimation(this.whyManaged);
            });
    }

    setDataReceived() {
        this.setState({
            dataReceived: true
        });
    }

    render() {
        return (
            <div ref={(el) => this.container = el} style={{opacity: 0}}>
                <HelmetDefault {...this.state} />
                <Hero title={this.state.title} subTitle={this.state.subTitle} leadCopy={this.state.leadCopy} dataReceived={this.state.dataReceived} />
                <TextImageHeading data={this.state.textImageHeading} />
                <div className="why-managed row">
                    <div className="col-md-6 col-md-offset-2 col-xs-12" ref={el => this.whyManaged = el}>
                        <Heading title={this.state.whyManaged.title} />
                        <p dangerouslySetInnerHTML={{__html: this.state.whyManaged.content}} />
                    </div>
                </div>
                <div className="bottom-wave-darkgreen" />
                <ThreeColumnIcons data={this.state.networkSolution} dataReceived={this.state.dataReceived} />
                <TwinColumn data={this.state.twinColumn} />
                <RegisterBlock />
            </div>
        );
    }

}

export default ManagedServices;


// WEBPACK FOOTER //
// ./resources/assets/js/pages/ManagedServices.js